
import React from 'react'
// import "@fontsource/ubuntu/700-italic.css";
// import "@fontsource/eb-garamond/800.css"; // EB Garamond weight 800
// import "@fontsource/eb-garamond/800-italic.css"; // EB Garamond italic weight 800

const P404 = () => {
  
  return (

    <div className="my-10 ">
        <div className='border-4 text  border-dashed border-blue-700 p-5 mx-8'>
        <div className='pb-4'><center><img src="https://cdn4.iconfinder.com/data/icons/pretticons-1/64/not-found-512.png" height={"100px"} width={"100px"} alt="" /></center></div>
  <h1 style={{ fontFamily: "'Ubuntu', serif", fontWeight: 300, fontStyle: "normal" }}>
    <center className="text-8xl font-bold text-transparent text-white" >
      <span className='text-blue-800 ' >4</span> 0 <span className='text-blue-800'>4</span>
    </center>
  </h1>
  <br />
  <center>
    <h1 className="text-5xl font- bg-gradient-to-r from-white to-blue-900 bg-clip-text text-transparent" style={{ fontFamily: "'Ubuntu', serif", fontWeight: 700, fontStyle: "italic" }}>
      Page Was Not Founds
    </h1>
  </center>
  </div>
</div>

  )
}

export default P404
